import AuthApi from "../../../../services/api/authApi.js";
import FooterNavigation from "./../../../footer/footer.vue";
import trackEvent from "@/services/tracking";

export default {
  components: {
    FooterNavigation,
  },
  data() {
    return {
      show: false,
      product: null,
      totalPrice: 0,
      unwatch: null,
      applymentType: "",
      form: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        requestAssortment: false,
        applymentType: "",
        storeBrandName: "",
      },
    };
  },

  computed: {
    isApplying() {
      return !!this.applymentType && !this.product;
    },
  },

  methods: {
    close: close,
    showQuickShopModalUnregisteredCallback: showQuickShopModalUnregisteredCallback,
    setApplymentType: setApplymentType,
    apply: apply,
    signup: signup,
  },

  mounted() {
    this.$eventBus.$on("apply-modal-unregistered", this.showQuickShopModalUnregisteredCallback);
  },

  beforeDestroy() {
    this.$eventBus.$off("apply-modal-unregistered", this.showQuickShopModalUnregisteredCallback);
  },
};

function apply() {
  this.$router.push({ path: "/wholesale-retail/brand" });
  this.close();
}
function signup() {
  this.$router.push({ path: "/wholesale-retail/buyer" });
  trackEvent("Retailer Button Click");
  this.close();
}

function showQuickShopModalUnregisteredCallback(product, applymentType = null) {
  this.product = product;
  this.show = true;

  if (applymentType) {
    this.applymentType = applymentType;
  } else if (this.$route.params.view) {
    this.applymentType = this.$route.params.view;
  } else {
    this.applymentType = "retailer";
  }

  this.setApplymentType(this.applymentType);
}

function close() {
  this.show = false;
}

function setApplymentType(applymentType) {
  applymentType = typeof applymentType == "object" ? applymentType.name : applymentType;

  if (applymentType == "brand") {
    this.form.applymentType = "brand";
    this.form.requestAssortment = false;
  } else if (applymentType == "assortment") {
    this.form.applymentType = "retailer";
    this.form.requestAssortment = true;
  } else {
    this.form.applymentType = "retailer";
    this.form.requestAssortment = false;
  }
}
